/* src/app/pages/op-exitosa-modal/op-exitosa-modal.component.css */
.popup-container {
  text-align: center;
  height: 100%;
  background: white;
  margin: 40px 71px;
}
.popup-content {
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.enviado {
  width: 500px;
  height: 124px;
}
.bold-text {
  font-family: "Gotham Medium";
  color: #323E48;
  font-size: 20px;
  margin: 0px;
  line-height: 24px;
}
.normal-text {
  position: relative;
  font-family: "Gotham Book";
  color: #5B6670;
  font-size: 15px;
  margin-top: 20px;
  margin-bottom: 40px;
  text-align: center;
  line-height: 23px;
}
.close-button {
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}
.close-button img {
  width: 100%;
  height: 100%;
  display: block;
}
.close-button:focus,
.close-button:focus-visible {
  outline: none;
  box-shadow: none;
}
.popup-image {
  height: 90px;
  width: 90px;
  margin-bottom: 10px;
}
.btn {
  font-family: "Gotham Medium";
  font-size: 15px;
  line-height: 18px;
  height: 45px;
  width: 121px;
  padding: 10px 30px;
  background-color: #EB0029;
  color: #FFFFFF;
  border-radius: 4px;
  border: none;
}
.btn:hover {
  background-color: #E30028;
  color: #FFFFFF;
}
.btn:active {
  background-color: #E30028 !important;
  color: #FFFFFF !important;
  box-shadow: inset 0 2px 4px rgba(104, 1, 1, 0.3) !important;
}
::ng-deep .modal-exitoso,
::ng-deep .modal-exitoso .mdc-dialog__surface {
  background: white !important;
  border-radius: 8px !important;
  padding: 0 !important;
  margin: 0 !important;
  width: 100% !important;
  max-width: 720px !important;
  overflow-x: hidden !important;
}
/*# sourceMappingURL=/banorte/__host/inmuebles/Inmuebles/op-exitosa-modal.component.css.map */
